export const CLARA_VEHICLE_INFO_VIEW = 'clara-vehicle-info-view';
